// import React from 'react';
// import Checkbox from '@mui/material/Checkbox';
// import { styled } from '@mui/material/styles';


// //checkbox white component material ui normal

// var styles = {
//   root: {
//     color: 'white',
//     '&$checked': {
//       color: 'white',
//     },
//     padding: '0px'
//   },
//   checked: {},
// };

// class CheckboxMaterialUIWhite extends React.Component {
//     state = { 
//         checkboxStatus: this.props.checkedStatus || false,   
//   };

//   handleChange = name => event => {
//       this.setState({ [name]: event.target.checked });
//       this.props.changeHandler(event.target.checked)
//   };

//   render() {
//     const { classes } = this.props;    
//     return ( 
//         <Checkbox
//           checked={this.props.checkedStatus}
//           onChange={this.handleChange('checkboxStatus')}
//           value="checkboxStatus"
//           classes={{
//             root: classes.root,
//             checked: classes.checked,
//           }}
//           />        
//     );
//   }
// }

// export default styled(styles)(CheckboxMaterialUIWhite);


// import React from 'react';
// import Checkbox from '@mui/material/Checkbox';
// // import { styled } from '@mui/material/styles';
// import { withStyles } from '@mui/styles';


// const StyledCheckbox = withStyles(Checkbox)({
//   color: 'white',
//   '&.Mui-checked': {
//     color: 'white',
//   },
//   padding: '0px',
// });

// class CheckboxMaterialUIWhite extends React.Component {
//   state = {
//     checkboxStatus: this.props.checkedStatus || false,
//   };

//   handleChange = (event) => {
//     this.setState({ checkboxStatus: event.target.checked });
//     this.props.changeHandler(event.target.checked);
//   };

//   render() {
//     return (
//       <StyledCheckbox
//         checked={this.props.checkedStatus}
//         onChange={this.handleChange}
//         value="checkboxStatus"
//       />
//     );
//   }
// }

// export default CheckboxMaterialUIWhite;


import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';

// ✅ Modern styled component
const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: 'white',
  '&.Mui-checked': {
    color: 'white',
  },
  padding: '0px',
}));

class CheckboxMaterialUIWhite extends React.Component {
  state = {
    checkboxStatus: this.props.checkedStatus || false,
  };

  handleChange = (event) => {
    this.setState({ checkboxStatus: event.target.checked });
    this.props.changeHandler(event.target.checked);
  };

  render() {
    return (
      // <StyledCheckbox
      //   checked={this.props.checkedStatus}
      //   onChange={this.handleChange}
      //   value="checkboxStatus"
      // />
      <input type='checkbox' onChange={this.handleChange} checked={this.props.checkedStatus}/>
    );
  }
}

export default CheckboxMaterialUIWhite;

